import { createMuiTheme } from '@material-ui/core/styles';
import { Theme } from '@emotion/react';
import themeConfig from '../../config/theme.yml';

export const primaryTheme = createMuiTheme({
    palette: {
        ...themeConfig.theme,
    },
}) as Theme;
